import { render, staticRenderFns } from "./Announcement.html?vue&type=template&id=1c3199ae&scoped=true&external"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
import style0 from "./Announcement.scss?vue&type=style&index=0&id=1c3199ae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3199ae",
  null
  
)

export default component.exports